import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	percent: number;
	isError?: boolean;
}

const ProgressBar = ({ className }: Props) => {
	return <div className={className} />;
};

const Memoized = memo(ProgressBar);

const getBackgroundColor = ({ percent, isError, theme }) => {
	if (percent < 100) {
		return theme.v2.color.neutral[1100];
	}
	if (isError) {
		return theme.v2.color.error[600];
	}
	return theme.v2.color.success[1000];
};

const Styled = styled(Memoized)`
	width: 100%;
	position: relative;
	height: 0.625rem;
	border-radius: 6.25rem;
	background-color: ${({ theme }) => theme.v2.color.secondary[200]};

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		transition: width 0.1s;
		max-width: 100%;
		height: 100%;
		width: ${({ percent }) => `${percent}%`};
		border-radius: 6.25rem;
		background-color: ${getBackgroundColor};
	}
`;

export { Styled as ProgressBar };
